import { assets } from "@/lib/assets";
import "@/components/landing/LiveVisitorShowcase.css";

export function LiveVisitorShowcase() {
  return (
    <section id="live-visitors" className="live-showcase-image-section" data-testid="live-visitor-showcase">
      <h2 className="sr-only" data-testid="live-showcase-heading">See your website come to life</h2>
      <img
        src={assets.landingLiveVisitors}
        width={1672}
        height={941}
        loading="lazy"
        decoding="async"
        alt="SEO Doctor illustration of live visitor analytics, showing example visitor locations on a world map, traffic sources, page views, and real-time alerts."
        data-testid="live-showcase-image"
      />
    </section>
  );
}